import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from './components/ui/toaster';
import GoldRain from './components/GoldRain';
import Home from './pages/Home';
import Documentaries from './pages/Documentaries';
import ProSports from './pages/ProSports';
import BrandStories from './pages/BrandStories';
import Trades from './pages/Trades';
import NotFound from './pages/NotFound';

function App() {
  return (
    <BrowserRouter>
      <div className="App">
        <GoldRain />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/documentaries" element={<Documentaries />} />
          <Route path="/pro-sports" element={<ProSports />} />
          <Route path="/brand-stories" element={<BrandStories />} />
          <Route path="/trades" element={<Trades />} />
          <Route path="/drone" element={<Navigate to="/documentaries" replace />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
        <Toaster />
      </div>
    </BrowserRouter>
  );
}

export default App;
